import React, { useRef, useState } from 'react';
import DefaultIcon from 'components/buttons/DefaultIcon/DefaultIcon';

import { faFileContract, faGear, faHeart, faSearch, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setShowEbookSidebar } from 'store/slices/ebooks.slice';
import './NavbarGroupBtns.scss';
import { useOnClickOutside } from 'utils/hooks/useOnClickOutside';
import { useDeviceDetect } from 'utils/hooks/deviceDetect';

type Props = {};

const ReliableFloatableButtons: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [buttonsAreaExpanded, setButtonsAreaExpanded] = useState<boolean>(false);
  const clickRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const { isMobile } = useDeviceDetect();


  useOnClickOutside(clickRef, () => {
    setButtonsAreaExpanded(false);
  });

  const changeAreaExpanded = () => {
    setButtonsAreaExpanded((prevState) => !prevState);
  };

  const goToFavourites = () => {
    navigate('/page/favorite');
  };

  const handleEbooksClick = () => {
    dispatch(setShowEbookSidebar(true));
  };


  return (
    isMobile ? (
      <div className="floatable-buttons-wrapper" ref={clickRef}>
        <DefaultIcon onClick={changeAreaExpanded} icon={!buttonsAreaExpanded ? faGear : faXmark} />
        <div className={`buttons ${buttonsAreaExpanded ? 'show' : 'hidden'}`}>
          {/* <DefaultIcon onClick={() => null} icon={faSearch} /> */}
          <DefaultIcon onClick={goToFavourites} icon={faHeart} />
          <DefaultIcon onClick={handleEbooksClick} icon={faFileContract} />
        </div>
      </div>
    ) : (
      <React.Fragment>
        {/* <DefaultIcon onClick={() => null} icon={faSearch} text={t('_rapid_search')} /> */}
        <DefaultIcon onClick={goToFavourites} icon={faHeart} text={t('_favorite')} />
        <DefaultIcon onClick={handleEbooksClick} icon={faFileContract} text={t('_catalog_ebooks')} />
      </React.Fragment>
    )
  );
};

ReliableFloatableButtons.displayName = 'ReliableFloatableButtons';

export default ReliableFloatableButtons;
